import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { firstValueFrom } from "rxjs";
import { GetToolsDto } from "../dtos/get-tools.dto";
import { URLS } from "../../constants/constants";
import { AuthService } from "../../../common/services/auth.service";
import { CreateToolDto } from "../dtos/tools.dto";


@Injectable()
export class ToolsService {
private http = inject(HttpClient);
private authService = inject(AuthService)
    
    getTools({skip,limit,sortField,sortOrder,searchQuery=undefined}:{skip:number,limit:number,sortField:string,sortOrder:string,searchQuery?:string}) : Promise<GetToolsDto>{
        let queryString = `skip=${skip}&limit=${limit}&sortField=${sortField}&sortOrder=${sortOrder}`;
        if(searchQuery && searchQuery !== '')
            queryString+=`&searchQuery=${searchQuery}`;
        return  firstValueFrom(this.http.get<GetToolsDto>(`${URLS.TOOLS_API}?${queryString}`, {
            headers: this.authService.getAuthHeaders()
        }));  
    }
    
    async createTool(createToolsDto:CreateToolDto){
        await firstValueFrom(this.http.post<CreateToolDto>(`${URLS.TOOLS_API}`,createToolsDto, {
            headers: this.authService.getAuthHeaders(),
        }));  
    }
}